import React, { useState } from 'react';

import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import Tooltip from '@material-ui/core/Tooltip';

import classes from '../../../components/ViewSelector.module.css';

const ReportsViewSelector = ({
    activeNavSite,
    view,
    handleChangeView,
    ...props
}) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const open = Boolean(anchorEl);
    const id = open ? 'nav-select-popover' : undefined;

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setMenuOpen(false);
    };

    const handleSelect = view => {
        handleChangeView(view);
        setAnchorEl(null);
        setMenuOpen(false);
    };

    return (
        <div>
            <Button
                className={classes.Button}
                aria-describedby={id}
                onClick={handleClick}
            >
                <Tooltip
                    classes={{ tooltip: classes.tooltip }}
                    title="view"
                    placement="bottom"
                >
                    <div className={classes.Selector}>
                        <p>View - {view} <i className={`fas fa-chevron-${menuOpen ? 'down' : 'up'}`} aria-hidden="true" /></p>
                    </div>
                </Tooltip>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical:   'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical:   'top',
                    horizontal: 'left',
                }}
            >
                <div>
                    <List>
                        <ListItem
                            key={0}
                            onClick={() => handleSelect('Inspection Reports')}
                            classes={{
                                root: classes.ListItem1
                            }}
                        >
                            Inspection Reports
                        </ListItem>
                        <ListItem
                            key={1}
                            onClick={() => handleSelect('Watchdog Reports')}
                            classes={{
                                root: classes.ListItem1
                            }}
                        >
                            Watchdog Reports
                        </ListItem>
                       
                    </List>
                </div>
            </Popover>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavSite: state.bob.activeNavSite
    };
};

export default connect(mapStateToProps, null)(ReportsViewSelector);
